import { Component, OnInit,  OnDestroy} from '@angular/core';
import * as $ from 'jquery';
import { CentralService} from '../servicios/central.service';
import {faSignInAlt, faKey, faEuroSign, faTractor, faMoneyBill, 
        faFileInvoice, faUndo, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import {AvisosComponent} from '../avisos/avisos.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import {Router } from '@angular/router';


@Component({
  selector: 'app-fichacaplis',
  templateUrl: './fichacaplis.component.html',
  styleUrls: ['./fichacaplis.component.css']
})
export class FichacaplisComponent implements OnInit, OnDestroy {

  dtOptions: any;
  dtTrigger: Subject<any> = new Subject();
  datosTabla: any = [{}];

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoFac = faFileAlt;
  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [this.icoKey, this.icoEur, this.icoTra, this.icoMny, this.icoInv, this.icoFac];

  resul: boolean;

  modoLis = 0;

  constructor(private srvCentral: CentralService, private modalService: NgbModal, private router: Router  ) { }

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== '') {
       const k = this.srvCentral.listaMnu.length;
       this.menu = [];
       for ( let i = 0; i < k; i++)  {
           this.menu.push(
             { nombre: this.srvCentral.listaMnu[i].nombre,
               ruta:  this.srvCentral.listaMnu[i].ruta,
               icono: this.iconos[this.srvCentral.listaMnu[i].ico]
           } );

       }
    }

    this.modoLis = this.srvCentral.FicModoLis;
    this.cargaTabla();
  }

  ngOnDestroy(): void {
      // NO OLVIDAR DESUSCRIBIR EL EVENTO
      this.dtTrigger.unsubscribe();
  }


  persiana() {
    $('#wrapper').toggleClass('toggled');
  }

  /*    *********   */
  cargaTabla(): void {
      this.dtOptions = {
         dom: 'Blfrtip',
         buttons: [],
         ordering: false,
         language: {
         thousands: '.',
         decimal: ',',
         emptyTable:     'No hay datos disponibles en la tabla',
         info:           'Mostrando de _START_ a _END_ de _TOTAL_ registros',
         infoEmpty:      'Mostrando de 0 a 0 de 0 registros',
         infoFiltered:   '(filtrado de _MAX_ registros totales)',
         infoPostFix:    '',
         lengthMenu:     'Mostrar _MENU_ registros',
         loadingRecords: 'Cargando...',
         processing:     'Procesando...',
         search:         'Buscar:',
         zeroRecords:    'No se encontraron registros coincidentes',
         paginate: {
            first:      'Primero',
            last:       'Último',
            next:       'Siguiente',
            previous:   'Anterior'
         },
         aria: {
            sortAscending:  ': activar para ordenar por columna ascendente',
            sortDescending: ': activar para ordenar por columna descendente'
           }
         }
      };
      this.cargaDatos();
  }


  cargaDatos() {
    this.resul = true;
    this.datosTabla = [];
    this.srvCentral.fichaCapital(this.modoLis, 0)
        .subscribe(datos => {
          if (datos[0].cpFecha === '?') {
            this.resul = false;
            const modalRef = this.modalService.open(AvisosComponent);
            modalRef.componentInstance.datAviso = {tit: 'ERROR SERVIDOR',
                                                   tex: datos[0].cpConce,
                                                   tip: 2,
                                                   btcan: '',
                                                   btno: '',
                                                   btsi: 'Aceptar'};
            modalRef.result.then((result) => {
            });

          } else {
               this.resul = false;
               this.datosTabla = [];
               for (const regis of datos) {
                    const tx = this.srvCentral.saca(regis.cpConce);
                    regis.cpConce = tx;
                    this.datosTabla.push(regis);
               }

          }
          this.dtTrigger.next();
    });

  }

 volver(): void {
  this.router.navigate(['/fichacap']);
 }

}
